module.exports = __webpack_public_path__ + "img/motor_no20.4452e5c1.jpg";